export const WITHDRAW_RECORD_STATUS = {
  0: '已完成',
  1: '1-3个工作日到账',
  3: '1-3个工作日到账',
  5: '未通过身份校验',
  8: '账号异常，提现失败',
  9: '1-3个工作日到账',
  11: '审核中',
  21: '失败，前往QQ钱包绑定银行卡后重试',
  22: '审核中',
};


export const EXCHANGE_RECORD_STATUS = {
  0: '发放成功',
  1: '正在处理',
  100: '正在处理',
  101: '正在处理',
  102: '正在处理',
  103: '正在处理',
  104: '发放成功',
};

export const INCOME_RECORD_STATUS = {
  100: '处理中',
  101: '处理中',
};
